import InvitationsDashboard from '../common/InvitationsDashboard';

export default function AdminInvitationsPage() {
  return <InvitationsDashboard role="ADMIN" title="All invitations" />;
}
